import Script from 'next/script'

type ProductPageScriptProps = {
	productId: number
}

export const ProductPageScript = (props: ProductPageScriptProps) => (
	<Script id="xcntmyAsync" strategy="lazyOnload">
		{`var xcnt_product_id = '${props.productId}'; 
        (function(d){ var xscr = d.createElement( 'script' ); xscr.async = 1; xscr.src =
'//x.cnt.my/async/track/?r=' + Math.random(); var x = d.getElementById( 'xcntmyAsync' );
x.parentNode.insertBefore( xscr, x ); })(document);`}
	</Script>
)
